import React, {Utils} from 'react'
import { Bar } from 'react-chartjs-2'

const LineGraphDaily = (props) => {
  var arr = [];
  
  // while(arr.length < 7){
  //     var r = Math.floor(Math.random() * 100) + 1;
  //     if(arr.indexOf(r) === -1) arr.push(r);
  // }
  console.log(arr);
  if (!props.data || props.data.length == 0) {
    return (
      <div>
        <Bar
         data={{
          datasets: [{
            label: 'no data available',
            fill: false,
            borderColor: '#EBE4C7',
            backgroundColor: '#EAD78C',
            tension: 0.1
          }]
        }} 
        
        height={300} width={500}
        style={{height: "300px"}}
        options={{
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          legend: {
            position: 'bottom',
            labels: {
              fontSize: 25,
            },
          },
          plugins: {
            legend: {
              position: 'bottom',
              align: 'end'
            },
          }
        }}
      />
      </div>
    );
  }
  let labels = props.data.map(d => d['_id']);
  let data = props.data.map(d => d.quantity);
  let barData = {
    labels: labels,
    datasets: [{
      label: props.dimension.label,
      data: data,
      fill: false,
      borderColor: '#EBE4C7',
      backgroundColor: '#EAD78C',
      tension: 0.1
    }]
  };
  let options = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    legend: {
      position: 'bottom',
      labels: {
        fontSize: 25,
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        align: 'end'
      },
    }
  };
  if (data.length <= 5) {
    options.indexAxis = 'y';
  }
  return (
    <div>
      <Bar data={barData} height={300} width={500} options={options} style={{height: "300px"}} />
    </div>
  )
}

export default LineGraphDaily